module.exports = __webpack_public_path__ + "img/D_Placeholder_Quidel_EN.3c8791af.jpg";